import { gql } from "@apollo/client";

export const CHECK_USER = gql`
  query CheckClientLoginId($clientName: String) {
    CheckClientLoginId(clientName: $clientName)
  }
`;